import { render, staticRenderFns } from "./person_duty_class.vue?vue&type=template&id=2c03998e&scoped=true"
import script from "./person_duty_class.vue?vue&type=script&lang=js"
export * from "./person_duty_class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c03998e",
  null
  
)

export default component.exports